import createIcon from '../../createIcon';

/**
 * @component @name MapsUgc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjUgMS41QzYuOTggMS41IDIuNSA1Ljk4IDIuNSAxMS41QzIuNSAxMy4wNCAyLjg2IDE0LjQ4IDMuNDcgMTUuNzlMMS41IDIyLjVMOC4yMSAyMC41M0M5LjUyIDIxLjE0IDEwLjk2IDIxLjUgMTIuNSAyMS41QzE4LjAyIDIxLjUgMjIuNSAxNy4wMiAyMi41IDExLjVDMjIuNSA1Ljk4IDE4LjAyIDEuNSAxMi41IDEuNVpNMTYuNSAxMi41SDEzLjVWMTUuNUgxMS41VjEyLjVIOC41VjEwLjVIMTEuNVY3LjVIMTMuNVYxMC41SDE2LjVWMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MapsUgc = createIcon('MapsUgc', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.5 1.5C6.98 1.5 2.5 5.98 2.5 11.5C2.5 13.04 2.86 14.48 3.47 15.79L1.5 22.5L8.21 20.53C9.52 21.14 10.96 21.5 12.5 21.5C18.02 21.5 22.5 17.02 22.5 11.5C22.5 5.98 18.02 1.5 12.5 1.5ZM16.5 12.5H13.5V15.5H11.5V12.5H8.5V10.5H11.5V7.5H13.5V10.5H16.5V12.5Z',
      key: '1m41oy',
    },
  ],
]);

export default MapsUgc;
